module.exports = __webpack_public_path__ + "static/media/PMvisit2018.4b401a75.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Experiences/Contents/PMvisit2018.md
// module id = 1073
// module chunks = 0